"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.materialCorrection = void 0;
const three_1 = require("three");
function materialCorrection(model) {
    model.traverse((node) => {
        var _a, _b;
        if (node.isMesh) {
            node.material.metalness = 0.5; // if metalness is 1, ambient light do not difuse from object
            if ((_b = (_a = node.material) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.colorSpace) {
                node.material.map.colorSpace = three_1.LinearSRGBColorSpace;
            }
        }
    });
}
exports.materialCorrection = materialCorrection;
